export default {
  outlined: {
    "&$marginDense": {
      transform: "translate(14px, 13px) scale(1)"
    }
  }
};
